import { ColDef, RowSpanParams } from 'ag-grid-community';
import { AccountingService } from '../accounting/services/accounting.service';

export function ReservedFirearmsTableColumnDef(
  accountingService: AccountingService
): ColDef[] {
  return [
    {
      // ID
      headerName: 'ID',
      field: '_id',
      resizable: true,
      width: 175,
      filter: 'agTextColumnFilter',
      hide: true,
    },
    {
      // Reservation ID
      headerName: 'Reservation ID',
      field: 'reservation_id',
      resizable: true,
      width: 120,
      filter: 'agTextColumnFilter',
      cellRenderer: 'rowspanCellRenderer',
      rowSpan: getRowSpan,
      hide: false,
    },
    {
      // Firearm ID
      headerName: 'Firearm ID',
      field: 'firearm_id',
      resizable: true,
      width: 100,
      filter: 'agTextColumnFilter',
    },
    {
      // Firearm
      headerName: 'Firearm',
      field: 'firearm',
      resizable: true,
      minWidth: 200,
      flex: 1,
      filter: 'agTextColumnFilter',
      tooltipField:'firearm',
    },
    {
      // Serial Number
      headerName: 'Serial Number',
      field: 'serial_number',
      resizable: true,
      width: 175,
      filter: 'agTextColumnFilter',
    },
    {
      // Reserved To
      headerName: 'Reserved To',
      field: 'reserved_to',
      resizable: true,
      width: 200,
      filter: 'agTextColumnFilter',
      cellRenderer: (params) => {
        return accountingService.getCustomerDisplayName(params.value);
      },
    },
    {
      // Reserved Date
      headerName: 'Reserved Date',
      field: 'reserved_date',
      resizable: true,
      width: 125,
      filter: 'agTextColumnFilter',
    },
    {
      // Reserved By
      headerName: 'Reserved By',
      field: 'reserved_by',
      resizable: true,
      width: 150,
      filter: 'agTextColumnFilter',
    },
    {
      // Notes
      headerName: 'Notes',
      field: 'notes',
      resizable: true,
      width: 200,
      tooltipField:'notes',
      filter: 'agTextColumnFilter',
    },
  ];
}
//Revert Reservation
function getRowSpan(params: any): number {
  const data = params.data;
  const node = params.node;
  const allRows = [];
  params.api.forEachNode((rowNode) => {
    allRows.push(rowNode.data);
  });
  let rowspan = 1;
  for (let i = node.rowIndex + 1; i < allRows.length; i++) {
    if (allRows[i].reservation_id === data.reservation_id) {
      rowspan++;
    } else {
      break;
    }
  }
  return rowspan;
}
